import React from 'react';
import Chart from 'react-apexcharts';
import './styles.css';

const BarChart = ({
  label,
  categories,
  values,
  horizontal,
  formatter = null,
  yAxis,
  generateColors,
}) => {
  const colors = generateColors(values ? values.length : 0);
  const formatterVal = formatter ? formatter : null;
  const data = {
    xaxis: {
      categories: categories && categories.length > 0 ? categories : [],
    },
    yaxis: {
      title: {
        text: yAxis ? yAxis : '',
      },
      labels: {
        formatter: (value) => (formatterVal ? formatterVal(value) : value),
      },
    },
    chart: {
      type: 'bar',
      redrawOnParentResize: true,
    },
    plotOptions: {
      bar: {
        horizontal: horizontal,
        distributed: true,
      },
    },
    dataLabels: {
      enabled: false,
      ...(formatterVal && { formatter: formatterVal }),
      style: {
        colors: ['#ffffff'],
      },
      background: {
        enabled: true,
        foreColor: '#000',
        borderRadius: 2,
        padding: 4,
        opacity: 0.9,
        borderWidth: 1,
        borderColor: '#000',
      },
    },
    colors: colors,
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            show: false,
          },
        },
      },
    ],
    legend: {
      position: 'right',
      offsetY: 0,
      height: 200,
      show: false,
    },
    tooltip: {
      enabled: true,
      y: {
        ...(formatterVal && { formatter: formatterVal }),
      },
    },
  };

  const sanitizedValues = values?.map((value) =>
    isNaN(value) ? 0 : Number(value)
  ) || [0];

  const series =
    sanitizedValues.length > 0
      ? [{ name: '', data: sanitizedValues }]
      : [{ name: '', data: [0] }];

  const dynamicWidth = values ? values.length * 100 : 0;
  const chartWidth = dynamicWidth < window.innerWidth ? '100%' : dynamicWidth;

  return (
    <div className="bar-wrap fix-height chart-wrap">
      {label ? <div className="grp-lbl">{label}</div> : null}
      <Chart
        type="bar"
        height={'300'}
        width={chartWidth}
        options={data}
        series={series}
      />
    </div>
  );
};

export default BarChart;
